module.exports = "uniform float point_size;";